import React, { memo } from 'react';
import PropTypes from 'prop-types';
import EntityCrudTab from 'containers/components/EntityCrud/EntityCrudTab';
import 'containers/components/EntityCrud/index.scss';
import { KPIS } from 'constants/Entities';

import './styles.scss';

const propTypes = {
    changeField: PropTypes.func,
    configMap: PropTypes.object,
    data: PropTypes.object,
    errors: PropTypes.array,
    firstErrorField: PropTypes.string,
    schema: PropTypes.object,
};

const CrudContent = memo(({ changeField, configMap, data, errors, firstErrorField, schema }) => {
    return (
        <div className="fm-crud-form kpis-crud-content">
            {schema &&
                schema.map((tab, index) => {
                    if (!tab.show) return null;
                    return (
                        <EntityCrudTab
                            key={`tab-${index}`}
                            changeField={changeField}
                            configMap={configMap}
                            data={data}
                            entity={KPIS}
                            errors={errors}
                            firstErrorField={firstErrorField}
                            indexTab={index}
                            tab={tab}
                        />
                    );
                })}
        </div>
    );
});

CrudContent.propTypes = propTypes;

export default CrudContent;
